<template>
    <BaseSection class="page-intro base-section--align-left">
        <template #page-title>
            <slot name="title" />
        </template>
        <template #intro>
            <slot name="intro" />
        </template>
    </BaseSection>
</template>

<style lang="less">
.page-intro {
    margin-top: var(--navbar-height);

    @media @q-md-min {
        margin-bottom: var(--spacing-lg);
    }
}

.base-section--align-left .base-section__header,
.base-section--align-left .base-section__intro {
    @media @q-md-max {
        grid-column: first / right-side-gutter;
    }
}
</style>